import { Flex } from "@aws-amplify/ui-react";

export function Header() {
    return (
        <Flex justifyContent="center">

        </Flex>
    );
}
